// extracted by mini-css-extract-plugin
export var layout = "team-module--layout--jRqgP";
export var team = "team-module--team--58h+-";